// Figma: no frame provided yet — built using the established design system (same
// Stack-of-sections shell as ../DashboardPage.js's TodayDashboard) per the "extrapolate"
// decision.
// LOGIC PORTED from LC2's CrmTab.js (commons/components/HomeTabs/CRM/CrmTab.js) —
// same `accountsWithAccessToRewards` allowlist (verbatim sfids) gating whether ./Invoice.js
// renders, same "always show residents" composition (see ./ResidentsTable.js).
//
// NOTE (see task instructions): the new Figma sidebar splits "CRM" and "Invoices" into two
// destinations, but LC2 only ever had one combined "CRM / Invoices" tab (see HomeTabs.js's
// old tabObjs) with no separate "Invoices-only" tab to port. This file ports that combined
// tab's content under the "CRM" destination, matching LC2 exactly. The `invoices` branch in
// DashboardPage.js is intentionally left untouched — whether it should show this same
// Invoice component or something else is a product decision, not made here.
// The Invoices block (Current / Past invoices) is hidden for now — uncomment the imports,
// the allowlist, `showInvoices` and the <Invoice /> line below to bring it back.
import React from 'react';
// import {useSelector} from 'react-redux';
import {Stack} from '@mui/material';

// import {getIsStakeAdmin} from '../../../app/store/reducers/session';
// import {getDashboardAccount} from '../../../app/store/reducers/dashboard';
import ResidentsTable from './ResidentsTable';
// import Invoice from './Invoice';

// const ACCOUNTS_WITH_ACCESS_TO_REWARDS = ['0014S00000D9ddBQAR', '001Pp000009x0qAIAQ', '0014S000004bYPPQA2', '0014S000004aYHhQAM'];

const CrmSection = () => {
    // const isStakeAdmin = useSelector(getIsStakeAdmin);
    // const dashboardAccount = useSelector(getDashboardAccount);

    // const showInvoices = isStakeAdmin || ACCOUNTS_WITH_ACCESS_TO_REWARDS.includes(dashboardAccount?.sfid);

    return (
        <Stack spacing={3}>
            {/* {showInvoices && <Invoice />} */}
            <ResidentsTable />
        </Stack>
    );
};

export default CrmSection;
